module.exports = __WEBPACK_EXTERNAL_MODULE_to_buffer_6118b12e__;